"use client";
import Image from "next/image";
import HighlightedText from "./HighlightedText";
import React from "react";
import { m, LazyMotion, domAnimation } from "framer-motion";
import { usePathname } from "next/navigation";
import ImageMasonry_Community_Layout1 from "./ImageMasonry/Community/Layout1";
import ImageMasonry_Invention_Layout1 from "./ImageMasonry/Invention/Layout1";
import ImageMasonry_Home_Layout1 from "./ImageMasonry/Home/Layout1";
import ImageMasonry_Heritage_Layout1 from "./ImageMasonry/Heritage/Layout1";
import ImageMasonry_Layout1 from "./ImageMasonry/Layout1";
import ImageMasonry_Layout2 from "./ImageMasonry/Layout2";

interface Picture {
  id: number;
  attributes: {
    url: string;
    name: string;
    alternativeText: string | null;
  };
}

interface ImageMasonryProps {
  data: {
    id: string;
    title: string;
    subtitle: string;
    layout: string;
    images: {
      data: Picture[];
    };
    isLive: boolean;
    isReversed: boolean;
    date: string;
    categorySlug: string;
    useH1Tag?: boolean;
    slug: string;
  };
}

export default function ImageMasonry({ data }: ImageMasonryProps) {
  const pathname = usePathname();
  const isCommunityPage = pathname === "/community";
  const isInventionPage = pathname === "/invention";
  const isHeritagePage = pathname === "/heritage";
  const isHomePage = pathname === "/";

  if (!data.isLive) return <></>;

  return isHomePage ? (
    <ImageMasonry_Layout2 data={data} />
  ) : (
    <ImageMasonry_Layout1 data={data} />
  );
}
